import { render, staticRenderFns } from "./NaturezaDespesaList.vue?vue&type=template&id=3901f89e"
import script from "./NaturezaDespesaList.vue?vue&type=script&lang=js"
export * from "./NaturezaDespesaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports